import React, { useEffect, useState } from "react";
import MedicalService from "../../Services/MedicalService";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";

function SocialHistory(props) {
  const [socialHistoryData, setSocialHistoryData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    patientSocialHistory();
  }, [props.selectedPatient]);

  const patientSocialHistory = () => {
    let payload = {
      patientId: props.selectedPatient,
      status: 1,
    };
    MedicalService.HSPatientSocialHistory(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setSocialHistoryData(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">Social History</h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
        </div>
      </div>
      <hr />
      <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        {socialHistoryData.length > 0 ? (
          socialHistoryData.map((user, i) => (
            <div
              className="relative"
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                <div className="bg-[#FFFDF4] border border-[#EFD659] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                  <p>
                    <strong>Social History :</strong> {user.description}
                  </p>
                  <p>
                    Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </p>
                </div>
              </div>

              {hoveredIndex === i && (
                <div
                  className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                  style={{ top: "200px", left: "100px" }}
                >
                  {" "}
                  {user.description && (
                    <p>
                      <strong>Social History :</strong> {user.description}
                    </p>
                  )}
                  {user.occupation && (
                    <p>
                      <strong>Occupation :</strong> {user.occupation}
                    </p>
                  )}
                  {user.maritalStatus && (
                    <p>
                      <strong>Marital Status:</strong> {user.maritalStatus}
                    </p>
                  )}
                  {user.familyRelation && (
                    <p>
                      <strong>Social relations with family:</strong>{" "}
                      {user.familyRelation}
                    </p>
                  )}
                  {user.friendsRelation && (
                    <p>
                      <strong>Social relations with friends:</strong>{" "}
                      {user.friendsRelation}
                    </p>
                  )}
                  {user.communityRelation && (
                    <p>
                      <strong>Social relations with community: </strong>{" "}
                      {user.communityRelation}
                    </p>
                  )}
                  {user.colleagueRelation && (
                    <p>
                      <strong>Social relations with people at work: </strong>{" "}
                      {user.colleagueRelation}
                    </p>
                  )}
                  <p>
                    <strong>Onset date:</strong>{" "}
                    {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </p>
                </div>
              )}
            </div>
          ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
    // <div>
    //   <div className=" w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
    //     <div className="header h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
    //       <h1 className="font-bold text-normal text-white mt-3">
    //         Social History
    //       </h1>
    //     </div>
    //     <div className="body h-[75%] items-center scrollwidth bg-white overflow-y-auto border-t-2">
    //       {
    //         socialHistoryData.length > 0 ?
    //           (
    //             socialHistoryData.map((user, i) =>
    //             (
    //               <div className="items-center m-3 p-2 text-sm border rounded-md">
    //                 <p className="font-semibold">
    //                   Social History:{" "}
    //                   <span className="font-medium text-gray-500">
    //                   {user.description}
    //                   </span>
    //                 </p>
    //                 <p className="font-semibold">
    //                   Occupation:{" "}
    //                   <span className="font-medium text-gray-500">{user.occupation}</span>
    //                 </p>
    //                 <p className="font-semibold">
    //                   Marital Status:{" "}
    //                   <span className="font-medium text-gray-500">{user.maritalStatus}</span>
    //                 </p>
    //                 <p className="font-semibold">
    //                   Social relations with family:{" "}
    //                   <span className="font-medium text-gray-500">{user.familyRelation}</span>
    //                 </p>
    //                 <p className="font-semibold">
    //                   Social relations with friends:{" "}
    //                   <span className="font-medium text-gray-500">{user.friendsRelation}</span>
    //                 </p>
    //                 <p className="font-semibold">
    //                   Social relations with community:{" "}
    //                   <span className="font-medium text-gray-500">{user.communityRelation}</span>
    //                 </p>
    //                 <p className="font-semibold">
    //                   Social relations with people at work:{" "}
    //                   <span className="font-medium text-gray-500">{user.colleagueRelation}</span>
    //                 </p>
    //                 <div className="ml-auto font-medium mt-2 flex justify-start">
    //                   <h5 className="text-gray-500 font-semibold text-sm">
    //                     Onset date: <span>{dayjs(user.givenDate).format('YYYY-MM-DD')}</span>
    //                   </h5>
    //                 </div>
    //               </div>
    //             ))
    //           )
    //           :
    //           null
    //       }

    //     </div>
    //     <div className="footer h-[44px] bg-secondaryColor rounded"></div>
    //   </div>
    // </div>
  );
}

export default SocialHistory;
